export default __webpack_public_path__ + "f2a89f5d060f268854f1a88abd31197b.ttf";